import * as ACTION_TYPES from './censusActionTypes';

export const censusReducerInitialState = {
	census: {
		hasError: false,
		isFetching: false,
		data: null,
		meta: null,
		error: undefined,
	},
};

export const censusReducer = (state = censusReducerInitialState, action) => {
	switch (action.type) {
		// Users actions
		case ACTION_TYPES.GET_CENSUS_REQUEST: {
			return {
				...state,
				isFetching: true,
				hasError: false,
				isLoggedIn: false,
				error: undefined,
			};
		}
		case ACTION_TYPES.GET_CENSUS_REQUEST_SUCCESS: {
			const { data } = action.payload;
			return {
				...state,
				census: {
					...state.census,
					isFetching: false,
					hasError: false,
					error: undefined,
					data,
				},
			};
		}

		case ACTION_TYPES.GET_CENSUS_REQUEST_FAILURE: {
			return {
				...state,
				census: {
					...state.census,
					isFetching: false,
					hasError: true,
					// error
				},
			};
		}
		case ACTION_TYPES.CLEAR_CENSUS_PARAMS: {
			return {
				...censusReducerInitialState,
			};
		}

		// END User actions

		// END Put User actions
		default: {
			return state;
		}
	}
};

export default censusReducer;

export const getCensusReducer = state => state.censusReducer;

// get
export const getCensus = state => getCensusReducer(state)?.census?.data;
export const getCensusIsFetching = state =>
	getCensusReducer(state)?.census?.isFetching;
